// extracted by mini-css-extract-plugin
export default {"app-page-sticky-header":"_1itlhk9","appPageStickyHeader":"_1itlhk9","hideOnMobile":"_3rf37x"};